import invariant from 'tiny-invariant';

import {
  ChartTypeOption,
  GraphChartType,
} from 'business/data-analysis/pages/graph/components/chart/types';
import { isRingParameter } from 'business/data-analysis/pages/graph/hooks/graph-context/is-ring-parameter';
import { GraphPageState } from 'business/data-analysis/pages/graph/hooks/graph-context/types';

export const updateParameter = (
  graphSet: GraphPageState,
  graphId: string,
  parameterUniqueId: string,
  update: {
    color?: string;
    aggregationType?: string;
    computeType?: string;
    chartType?: ChartTypeOption;
  },
): GraphPageState => {
  const graphs = graphSet.structure.graphs;

  const graphToModify = graphs.get(graphId);
  invariant(
    graphToModify,
    'Trying to update a parameter of a non-existing graph',
  );

  const parameter = graphToModify.parameters.get(parameterUniqueId);
  invariant(parameter, 'Trying to update a non-existing parameter');

  const ringParameter = isRingParameter(graphSet, parameter)
    ? {
        aggregationType: update.aggregationType ?? parameter.aggregationType,
        computeType: update.computeType ?? parameter.computeType,
      }
    : {};

  const updatedParameter = {
    ...parameter,
    color: update.color ?? parameter.color,
    chartType: update.chartType ?? parameter.chartType,
    ...ringParameter,
  };

  graphToModify.parameters.set(parameterUniqueId, updatedParameter);

  if (update.chartType) {
    if (
      // Set graph global chart type to custom if any parameter has not the
      // same chart type as the others
      Array.from(graphToModify.parameters.values()).some(
        (param) => param.chartType !== update.chartType,
      )
    ) {
      graphToModify.chartType = GraphChartType.CUSTOM;
    } else if (
      Array.from(graphToModify.parameters.values()).every(
        (param) => param.chartType === update.chartType,
      )
    ) {
      graphToModify.chartType = update.chartType;
    }
  }

  graphs.set(graphId, graphToModify);

  return {
    ...graphSet,
    structure: {
      ...graphSet.structure,
      graphs,
    },
  };
};
